import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from "react-redux";
import { parseToArray } from '../libs/Util';
import { showToast } from '../Common/Messages';

const PathFinder = () => {
    const LoginStates = useSelector(state => state.login);
    const [releaseData, setReleaseData] = useState([]);
    const [listGroup, setListGroup] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [pathFinder, setPathFinder] = useState(null);
    const location = useLocation();
    const history = useNavigate();
    const maxVisibleItems = 3; // 한 번에 표시할 card 수

    const fetchReleaseContent = async () => {
        setListGroup([]);
        const body = {
            workingTag: location.pathname.replace('/',''),
            pageNum: 1,
            rowNum: 30,
        };
        try {
            const response = await fetch(`api/Document/GetReleaseContentList`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json; charset=utf-8',
                },
                body: JSON.stringify(body),
            });

            const result = await response.json();

            if (result && result.table.length > 0) {
                setReleaseData(result.table);
            }
            else {
                setReleaseData([]);
            }
        } catch (error) {
            console.error("Error fetchReleaseContent:", error);
        }
    }
    useEffect(() => {
        fetchReleaseContent();
    }, []);

    useEffect(() => {
        fetchReleaseContent();
    }, [location.pathname]);

    useEffect(() => {
        const setManualList = () => {
            if (releaseData.length > 0) {
                const array = [];
                for (let i = 0; i < releaseData.length; i += maxVisibleItems) {
                    array.push(releaseData.slice(i, i + maxVisibleItems))
                }
                setListGroup(array);
            }
        }
        setManualList();
    }, [releaseData]);

    useEffect(() => {
        if (location.state !== null)
            setPathFinder(location.state);
    }, [location]);

    useEffect(() => {
        if(pathFinder?.data?.access && !pathFinder?.data?.access.some(x => x.type === "" || (x.type === "userId" ? LoginStates[x.type] !== "" : LoginStates[x.type] ? LoginStates[x.type]?.split(',').filter(x => x.trim() !== "")?.includes(x.value) : true))) {
            showToast("warning", "접근 권한이 없습니다.");
            history("/");
            return;
        }
        if(pathFinder?.data.hasSub === false) history(`/document/${pathFinder.data.route}`, {replace: true});
        setCurrentIndex(0);
    }, [pathFinder]);

    if (pathFinder == null) {
        history("/");
        return null;
    }
    

    const props = pathFinder.data;
    const handlePageChange = (direction) => {
        setCurrentIndex((prevcurrentIndex) => {
            if (direction === "prev") {
                return prevcurrentIndex > 1 ? prevcurrentIndex - 1 : 0;
            } else if (direction === "next") {
                return prevcurrentIndex + 1;
            }
        });
    };
    const topWrap = () => {
        if (props.subtype === 1) {
            const submenu = props.submenu.map((x, index) => {
                return x.visible !== false && (
                    <li className="top-box" key={index}>
                        <a role="button" onClick={() => history(`${location.pathname}/${x.route}`)}>
                            <div className={`top-box-img-${x.class}`}></div>
                            <p className="top-box-sub">{x.description}</p>
                            <i className="icoKdc40 arrow"></i>
                        </a>
                    </li>
                );
            });
            return (
                <ul className="top-wrap">
                    {submenu}
                </ul>
            );
        } else if (props.subtype === 2) {
            const submenu = props.submenu.map((x, index) => {
                return (
                    <li className={`top-box top-box-${x.route}`} key={index}>
                        <a role="button" onClick={() => history(`${location.pathname}/${x.route}`)}>
                            <div className="top-box-top">
                                <h2 className="top-box-title">{x.title}</h2>
                                <i className="icoKdc40 arrow-w"></i>
                            </div>
                            {x.quickmenu.length > 0 ?
                                <ul className="top-box-list">
                                    {x.quickmenu.map((q, index) => {
                                        return (
                                            <li key={index}>
                                                <i className={`icoKdc20 ${q.class}`}></i>
                                                <span className="top-box-list-span">{q.title}</span>
                                            </li>
                                        );
                                    })}
                                </ul>
                                : null
                            }
                        </a>
                    </li>
                );
            });
            return (
                <ul className="top-wrap">
                    {submenu}
                </ul>
            );
        }
    }
    const containerStyle = {
        display: "flex",
        overflow: "hidden"
    }

    const animationStyle = {
        minWidth: "100%",
        transform: `translateX(-${currentIndex * 100}%)`,
        transition: "transform 0.5s ease-in-out"
    }
    const updateList = () => {
        return (
            <div className="updates">
                <div className="updates-top">
                    <h2 className="section-title">업데이트된 매뉴얼</h2>
                    <div className="btn-swiper">
                        <Link
                            role="button"
                            className={currentIndex === 0 && 'dis'}
                            onClick={() => handlePageChange("prev")}
                        >
                            <i className="icoKdc40 prev"></i>
                        </Link>
                        <Link
                            role="button"
                            className={currentIndex === listGroup.length - 1 ? 'dis' : ''}
                            onClick={currentIndex === listGroup.length - 1 ? null : () => handlePageChange("next")}
                        >
                            <i className="icoKdc40 next"></i>
                        </Link>
                    </div>
                </div>
                <div className="updates-bottom" style={containerStyle}>
                    {listGroup.map((group, i) => {
                        return (
                            <ul className={`slide-box-wrap`} style={animationStyle} key={i}>
                                {group?.map((item, index) => {
                                    let category = '';
                                    if (item.category.includes("/")) {
                                        category = item.category.split("/").pop();
                                    }
                                    return (
                                        <li className="slide-box" key={index}>
                                            <a role="button" onClick={() => history(`/${item.path}`)}>
                                                <div className="slide-box-kdcnews-top" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <div className="slide-box-badge">
                                                        <i className={`icoKdc24 ${item.type}`}></i>
                                                        <p className={`slide-box-badge-${item.type}`}>{item.message}</p>
                                                    </div>
                                                    <span className="date">{item.updateDate}</span>
                                                </div>
                                                <div className="slide-box-manual-bottom">
                                                    <h4 className="box-cate">{category}</h4>
                                                    <h3 className="box-title">{item.title}</h3>
                                                    <div className="box-tags">
                                                        {parseToArray(item.tag).map((tag, tagIndex) => (
                                                                <span key={tagIndex}>{tag}</span>
                                                            ))}
                                                    </div>
                                                    {item.fullPath && (
                                                        <div className="path" key={index}>
                                                            {JSON.parse(item.fullPath).map((path, index, arr) => (
                                                                <React.Fragment key={index}>
                                                                    <span className="path-li">{path}</span>
                                                                    {index < arr.length - 1 && <i className="icoKdc12 next"></i>}
                                                                </React.Fragment>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            </a>
                                        </li>
                                    );
                                })}
                            </ul>
                        );
                    })}
                </div>
            </div>
        );
    }
    return (
        <div className="container contents-wrapper">
            <div className={props.subtype > 1 ? "contents-wrapper-width developments" : "contents-wrapper-width tools"}>
                <h1 className="page-title">{props.title}</h1>
                <div className="page-bar">
                    <h3 className="page-intro">{props.intro?.description}</h3>
                    <i className={`page-intro-${props.intro?.image}`}></i>
                </div>
                {topWrap()}
                {updateList()}
            </div>
        </div>

    );
}

export default PathFinder;